import { NgModule } from '@angular/core';
import { SfoAdmonitionComponent } from './admonition';
import { SfoRichTextInputComponent } from './rich-text';

@NgModule({
  declarations: [],
  imports: [SfoAdmonitionComponent, SfoRichTextInputComponent],
  exports: [SfoAdmonitionComponent, SfoRichTextInputComponent],
})
export class SfoWidgetModule {}
